export default defineNuxtPlugin(() => {
  const colorMode = useColorMode()

  const syncTheme = (value: string) => {
    document.documentElement.setAttribute('data-theme', value)
  }

  syncTheme(colorMode.value)

  watch(() => colorMode.value, syncTheme)
})
